import classes from "./ReleaseActivityPage.module.css";
import ViewActivityInfoIcon from "./ViewActivityInfoIcon";
import React, {useEffect, useState} from "react";
import {
    BACK_TEXT, BROWSER_TYPES,
    BUTTON,
    GRADE_BOOK_TEXT, PLATFORM_TYPES,
    POLL_TYPE, RELEASE_ACTIVITY_VIEW,  TITLE_HEADER,
} from "../../utils/constants";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useHistory, useParams} from "react-router-dom";
import {ReactComponent as CARD_ICON} from "./images/card_icon.svg";
import {ReactComponent as TREND_ICON} from "./images/trend_icon.svg";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import ViewMetricCardResponsesDoughnutChart from "./ViewMetricCardResponsesDoughnutChart";
import {convertPercentage, removePrefixNew} from "../../utils/helpers";

import ViewMetricParticipantsTable from "./ViewMetricParticipantsTable";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import { Tab, Tabs } from "react-bootstrap";


export default function ViewMetrics({
                                        pollData,
                                        participantsOverallData,
                                        browserAnalysisData,
                                        participants=[],
                                        columns = [{Header: TITLE_HEADER}],
                                        setPageView,
}) {
    const { pollKey, pollCode } = useParams();
    let history = useHistory();
    const { getResultByGradeBookPerspective, getAttendanceGradebookResult } = ResponseApiCalls();

    const {poll = {}, questions = []} = pollData;
    const {pollTitle, gradeSchema, pollType, geofence} = poll;

    const btnStyle = {width: 130, height: 40, display: "flex", alignItems: "center", justifyContent: "center"};

    const gridLayout = {display: "grid", alignItems: "center", gridTemplateColumns: "minmax(0, 1fr) auto", gap: 5};

    const COLOR_SECTION = {CORRECT: "#429B6D", INCORRECT: "#E55F5A"};
    const BADGE_COLOR_SECTION = {CORRECT: "#D6E5DE", INCORRECT: "#FCDFDE"};
    const BROWSER_COLOR_SECTION = {CHROME: "#4F75CB", EDGE: "#E992D8", SAFARI: "#E19278", FIREFOX: "#EBBE79", MOBILE_APP: "#81CCC9", OTHER: "#928FDC"};
    const BROWSER_BADGE_COLOR_SECTION = {CHROME: "#D3DCF2", EDGE: "#E992D840", SAFARI: "#E1927840", FIREFOX: "#EBBE7940", MOBILE_APP: "#81CCC940", OTHER: "#928FDC40"};


    const PLATFORM_COLOR_SECTION = {APPLE: "#4F75CB", WINDOWS: "#E992D8", ANDROID: "#E19278", OTHER: "#EBBE79"};
    const PLATFORM_BADGE_COLOR_SECTION = {APPLE: "#D3DCF2", WINDOWS: "#E992D840", ANDROID: "#E1927840", OTHER: "#EBBE7940"};

    const [activeTab1, setActiveTab1] = useState("0");
    const [activeTab2, setActiveTab2] = useState("0");

    const [emptyDoughnutChartData, ] = useState(() => {
        let data = [];
        data.push({name: "correct", value: 1, fill: "#E1E1E1"});
        data.push({name: "incorrect", value: 2, fill: "#E1E1E1"});
        return data;
    });

    const [doughnutChartData, setDoughnutChartData] = useState([]);


    const [browserChartData, setBrowserChartData] = useState([]);
    const [browserTitle, setBrowserTitle] = useState("");
    const [emptyBrowserChartData, setEmptyBrowserChartData] = useState([
        {name: "other", value: 1, fill: "#E1E1E1"}
    ]);

    const [platformChartData, setPlatformChartData] = useState([]);
    const [platformTitle, setPlatformTitle] = useState("");
    const [emptyPlatformChartData, setEmptyPlatformChartData] = useState([
        {name: "other", value: 1, fill: "#E1E1E1"}
    ]);

    const [participantsData, setParticipantsData] = useState([]);
    const [gradeBookResponses, setGradeBookResponses] = useState([]);

    const [dataLoading, setDataLoading] = useState(true);

    const viewGradeBook = () => {
        history.push({
            pathname: "/gradeBook",
            state: {pollKey: pollKey, uniqueCode: pollCode, pollType: pollType}
        });
    }

    useEffect(() => {
        let func = pollType !== POLL_TYPE.ATTENDANCE ? getResultByGradeBookPerspective : getAttendanceGradebookResult;
        setDataLoading(true);
        func(pollKey, pollCode).then((res) => {
            const {gradeBookBreakdownResult={}} = res;
            let actualRes = pollType === POLL_TYPE.ATTENDANCE ? res : gradeBookBreakdownResult;
            const {responses=[]} = actualRes;
            setGradeBookResponses(responses);
        }).finally(() => {
            setDataLoading(false);
        });

    }, []);


    useEffect(() => {
        let participantsDataCopy = JSON.parse(JSON.stringify(participants));
        for (const participant of participantsDataCopy) {
            let userId = removePrefixNew(participant.pollSortKey);
            let response = gradeBookResponses.find(r => r.userId === userId);
            if (response)  {
                participant.name = response.firstName + (response.lastName ? " " + response.lastName : "");
            } else {
                participant.name = "";
            }
        }

        setParticipantsData(participantsDataCopy);

    }, [participants, gradeBookResponses]);


    useEffect(() => {
        let doughnutChartDataCopy = [];
        doughnutChartDataCopy.push({name: "attempted", value: participantsOverallData.attempted, fill: COLOR_SECTION.CORRECT});
        doughnutChartDataCopy.push({name: "unattempted", value: participantsOverallData.unattempted, fill: COLOR_SECTION.INCORRECT});
        setDoughnutChartData(doughnutChartDataCopy);
    }, [participantsOverallData]);


    useEffect(() => {


        let browserDataCopy = [];
        browserDataCopy.push({name: BROWSER_TYPES.Chrome, value: browserAnalysisData.chrome, fill: BROWSER_COLOR_SECTION.CHROME});
        browserDataCopy.push({name: BROWSER_TYPES.Edge, value: browserAnalysisData.edge, fill: BROWSER_COLOR_SECTION.EDGE});
        browserDataCopy.push({name: BROWSER_TYPES.Safari, value: browserAnalysisData.safari, fill: BROWSER_COLOR_SECTION.SAFARI});
        browserDataCopy.push({name: BROWSER_TYPES.Firefox, value: browserAnalysisData.firefox, fill: BROWSER_COLOR_SECTION.FIREFOX});
        browserDataCopy.push({name: BROWSER_TYPES.MobileApp, value: browserAnalysisData.mobileApp, fill: BROWSER_COLOR_SECTION.MOBILE_APP});
        browserDataCopy.push({name: BROWSER_TYPES.Other, value: browserAnalysisData.otherBrowser, fill: BROWSER_COLOR_SECTION.OTHER});
        setBrowserChartData(browserDataCopy);
        const maxBrowser = browserDataCopy.reduce((max, item) =>
            item.value > max.value ? item : max
        );
        setBrowserTitle(maxBrowser.name);

        let platformDataCopy = [];
        platformDataCopy.push({name: PLATFORM_TYPES.iPhone, value: browserAnalysisData.apple, fill: PLATFORM_COLOR_SECTION.APPLE});
        platformDataCopy.push({name: PLATFORM_TYPES.Windows, value: browserAnalysisData.windows, fill: PLATFORM_COLOR_SECTION.WINDOWS});
        platformDataCopy.push({name: PLATFORM_TYPES.Android, value: browserAnalysisData.android, fill: PLATFORM_COLOR_SECTION.ANDROID});
        platformDataCopy.push({name: BROWSER_TYPES.Other, value: browserAnalysisData.otherPlatform, fill: PLATFORM_COLOR_SECTION.OTHER});
        setPlatformChartData(platformDataCopy);
        const maxPlatform = platformDataCopy.reduce((max, item) =>
            item.value > max.value ? item : max
        );

        setPlatformTitle(maxPlatform.name);

    }, [browserAnalysisData]);



    return (
        <div className={classes.parentContainer} style={{height: "unset", flex: 1}}>
            <div className={classes.mainCard}>
                <div className={classes.row} style={{gap: 7, minWidth: 120}}>
                    <span
                        tabIndex={0}
                        style={{cursor: "pointer", display: "flex", alignItems: "center"}}
                        onClick={() => setPageView(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW)}
                    >
                        <BACK style={{marginRight: 2}}/>
                        <span>{BACK_TEXT}</span>
                    </span>
                    <div style={{width: 5}}/>

                    <h1 className={classes.pollTitleText}>{pollTitle}</h1>
                    <ViewActivityInfoIcon pollData={pollData}/>

                    <div style={{flex: 1}}/>

                    <YuJaButton
                        tabIndex={0}
                        onClick={viewGradeBook}
                        style={{...btnStyle, marginLeft: 10}}
                    >
                        {GRADE_BOOK_TEXT}
                    </YuJaButton>
                </div>

                <div className={classes.row}
                     style={{flex: 1, minHeight: 0, gap: 20, flexWrap: "wrap", alignItems: "unset"}}>
                    <div className={`${classes.card} ${classes.column}`}
                         style={{flex: 1, minWidth: 440, height: 550, maxHeight: "100%"}}>
                        <div className={`${classes.cardHeader} ${classes.row}`}>
                            <CARD_ICON style={{marginRight: 7}}/>
                            <h2 style={{fontSize: 15, fontWeight: 600, marginBottom: 0}}>{"Participant Details"}</h2>
                        </div>

                        <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0}}>
                            <span className={classes.description} style={{marginBottom: 15}}>
                                {"View performance insights to understand participant engagement."}
                            </span>
                            <Tabs>
                                <Tab role={"tabpanel"} eventKey="Performance Data" title="Performance Data">
                                    <div className={classes.cardGridLayout} style={{marginTop: 25}}>
                                        <div className={classes.column}>
                                        <span className={classes.title} style={{color: "#000"}}>
                                            {"Completion Rate"}
                                        </span>
                                            <span className={classes.description}>
                                            {"Shows what percentage of participants completed the poll."}
                                        </span>
                                        </div>
                                        <div
                                            className={classes.row}
                                            style={{
                                                width: 200,
                                                gap: 7,
                                                height: "fit-content",
                                                justifyContent: "center"
                                            }}
                                        >
                                        <span className={classes.cardPercentage}>
                                            {convertPercentage(participantsOverallData.attempted, participantsOverallData.total)}
                                        </span>
                                            <TREND_ICON/>
                                        </div>


                                        <div className={classes.column}
                                             style={{gap: 5, maxWidth: 200, alignSelf: "center"}}>
                                            <div style={gridLayout}>
                                                <div className={classes.row}>
                                                <span className={classes.metricCardLegend}
                                                      style={{background: COLOR_SECTION.CORRECT}}/>
                                                    <span className={classes.metricCardLegendLabel}>{"Complete"}</span>
                                                </div>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{
                                                        background: BADGE_COLOR_SECTION.CORRECT,
                                                        width: "100%",
                                                        padding: "0 10px"
                                                    }}
                                                >
                                                    {participantsOverallData.attempted} /{participantsOverallData.total}
                                                </div>

                                                <div className={classes.row}>
                                                <span className={classes.metricCardLegend}
                                                      style={{background: COLOR_SECTION.INCORRECT}}/>
                                                    <span
                                                        className={classes.metricCardLegendLabel}>{"Incomplete"}</span>
                                                </div>

                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{
                                                        background: BADGE_COLOR_SECTION.INCORRECT,
                                                        width: "100%",
                                                        padding: "0 10px"
                                                    }}
                                                >
                                                    {participantsOverallData.unattempted} /{participantsOverallData.total}
                                                </div>
                                            </div>
                                        </div>


                                        <ViewMetricCardResponsesDoughnutChart
                                            countData={doughnutChartData}
                                            emptyCountData={emptyDoughnutChartData}
                                            title={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div style={{fontSize: 23, fontWeight: "700", color: "#292929"}}>
                                                        {participantsOverallData.total}
                                                    </div>
                                                    <div style={{
                                                        fontWeight: "600",
                                                        color: "#3C3C3C"
                                                    }}>{"Participants"}</div>
                                                </div>
                                            }
                                            emptyTitle={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div style={{fontSize: 23, fontWeight: "700", color: "#292929"}}>
                                                        0
                                                    </div>
                                                    <div style={{
                                                        fontWeight: "600",
                                                        color: "#3C3C3C"
                                                    }}>{"Participants"}</div>
                                                </div>
                                            }
                                        />

                                    </div>
                                </Tab>

                                <Tab role={"tabpanel"} eventKey="Participant List" title="Participant List">
                                    <div className={classes.column} style={{flex: 1, minHeight: 0}}>
                                        <ViewMetricParticipantsTable pollType={pollType} data={participantsData} columns={columns}
                                                                     dataLoading={dataLoading}/>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                    <div className={`${classes.card} ${classes.column}`} style={{flex: 1, minWidth: 440, height: 550,  maxHeight: "100%"}}>
                        <div className={`${classes.cardHeader} ${classes.row}`}>
                            <CARD_ICON style={{marginRight: 7}}/>
                            <h2 style={{fontSize: 15, fontWeight: 600, marginBottom: 0}}>{"Browser & Device Details"}</h2>
                        </div>

                        <div className={classes.column} style={{padding: 20, flex: 1, minHeight: 0}}>
                            <span className={classes.description} style={{marginBottom: 15}}>
                                {"View performance insights to understand participant engagement."}
                            </span>

                            <Tabs>
                                <Tab role={"tabpanel"} eventKey="Browsers" title="Browsers">
                                    <div style={{flex: 1}}/>
                                    <div className={classes.row}>
                                        <div style={{flex: 2}}/>
                                        <ViewMetricCardResponsesDoughnutChart
                                            countData={browserChartData}
                                            emptyCountData={emptyBrowserChartData}
                                            title={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div style={{fontSize: 23, fontWeight: "700", color: "#292929"}}>
                                                        {browserTitle}
                                                    </div>
                                                    <div style={{fontWeight: "600", color: "#3C3C3C"}}>{"Browser"}</div>
                                                </div>
                                            }
                                            emptyTitle={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div style={{fontWeight: "600", color: "#3C3C3C"}}>{"Browser"}</div>
                                                </div>
                                            }
                                        />
                                        <div style={{flex: 3}}/>

                                        <div className={classes.column} style={{width: 180, gap: 5, flexShrink: 0}}>
                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.CHROME}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Chrome}</div>

                                                <div style={{flex: 1}}/>

                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.CHROME,}}
                                                >
                                                    {browserAnalysisData.chrome}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.EDGE}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Edge}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.EDGE,}}
                                                >
                                                    {browserAnalysisData.edge}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.SAFARI}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Safari}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.SAFARI,}}
                                                >
                                                    {browserAnalysisData.safari}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.FIREFOX}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Firefox}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.FIREFOX,}}
                                                >
                                                    {browserAnalysisData.firefox}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.MOBILE_APP}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.MobileApp}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.MOBILE_APP,}}
                                                >
                                                    {browserAnalysisData.mobileApp}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: BROWSER_COLOR_SECTION.OTHER}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Other}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: BROWSER_BADGE_COLOR_SECTION.OTHER,}}
                                                >
                                                    {browserAnalysisData.otherBrowser}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{flex: 3}}/>

                                    </div>
                                    <div style={{flex: 1}}/>
                                </Tab>
                                <Tab role={"tabpanel"} eventKey="Platforms" title="Platforms">
                                    <div style={{flex: 1}}/>
                                    <div className={classes.row}>
                                        <div style={{flex: 2}}/>

                                        <ViewMetricCardResponsesDoughnutChart
                                            countData={platformChartData}
                                            emptyCountData={emptyPlatformChartData}
                                            title={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div style={{fontSize: 23, fontWeight: "700", color: "#292929"}}>
                                                        {platformTitle}
                                                    </div>
                                                    <div
                                                        style={{fontWeight: "600", color: "#3C3C3C"}}>{"Platform"}</div>
                                                </div>
                                            }
                                            emptyTitle={
                                                <div className={classes.column} style={{alignItems: "center", gap: 10}}>
                                                    <div
                                                        style={{fontWeight: "600", color: "#3C3C3C"}}>{"Platform"}</div>
                                                </div>
                                            }
                                        />

                                        <div style={{flex: 3}}/>

                                        <div className={classes.column} style={{width: 170, gap: 5, flexShrink: 0}}>
                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: PLATFORM_COLOR_SECTION.APPLE}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{PLATFORM_TYPES.iPhone}</div>

                                                <div style={{flex: 1}}/>

                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: PLATFORM_BADGE_COLOR_SECTION.APPLE,}}
                                                >
                                                    {browserAnalysisData.apple}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: PLATFORM_COLOR_SECTION.WINDOWS}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{PLATFORM_TYPES.Windows}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: PLATFORM_BADGE_COLOR_SECTION.WINDOWS,}}
                                                >
                                                    {browserAnalysisData.windows}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: PLATFORM_COLOR_SECTION.ANDROID}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{PLATFORM_TYPES.Android}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: PLATFORM_BADGE_COLOR_SECTION.ANDROID,}}
                                                >
                                                    {browserAnalysisData.android}
                                                </div>
                                            </div>

                                            <div className={classes.row}>
                                            <span className={classes.metricCardLegend}
                                                  style={{background: PLATFORM_COLOR_SECTION.OTHER}}/>
                                                <div
                                                    className={classes.metricCardLegendLabel}>{BROWSER_TYPES.Other}</div>
                                                <div style={{flex: 1}}/>
                                                <div
                                                    className={classes.metricCardLegendBadge}
                                                    style={{background: PLATFORM_BADGE_COLOR_SECTION.OTHER,}}
                                                >
                                                    {browserAnalysisData.otherPlatform}
                                                </div>
                                            </div>
                                        </div>

                                        <div style={{flex: 3}}/>
                                    </div>
                                    <div style={{flex: 1}}/>
                                </Tab>
                            </Tabs>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}